import React, { useCallback, useEffect } from 'react'
import { Button, IconSocialAppleDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { initAppleSignIn, appleSignIn } from '../../services'
import classes from './AppleButton.module.scss'

interface AppleButtonProps {
  onLogin?(...args: unknown[]): unknown
  onClick?: () => void
  t?(...args: unknown[]): unknown
}

const AppleButton = ({ onLogin, onClick }: AppleButtonProps) => {
  useEffect(() => {
    initAppleSignIn()
  }, [])

  const { t } = useTranslation('@mc/authentication')

  const handleClick = useCallback(async () => {
    onClick?.()
    const data = await appleSignIn()
    if (onLogin && data) {
      onLogin(data)
    }
  }, [onLogin, onClick])

  return (
    <Button kind='apple' fullWidth onClick={handleClick}>
      <IconSocialAppleDefault size='lg' className={`${classes.icon} mc-mr-3`} />
      {t('apple')}
    </Button>
  )
}

export default AppleButton
